import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email.trim()) {
      setErrorMsg('请输入邮箱地址');
      setStatus('error');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9q1447nahb7382ov4f0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
        setErrorMsg('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
          setStatus('success');
          setEmail('');
        } else {
          setErrorMsg(serverMsg || '订阅失败，请稍后重试');
          setStatus('error');
        }
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
      setStatus('error');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-xl mx-auto text-center">
        <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
          订阅路线更新通知
        </h2>
        <p className="text-foreground-600 text-sm mb-8 leading-relaxed">
          订阅我们的邮件通知，第一时间获取最新路线更新和访问教程。我们承诺不会发送垃圾邮件。
        </p>

        {status === 'success' ? (
          <div className="p-5 rounded-2xl bg-secondary-100 border border-secondary-200">
            <div className="flex items-center justify-center gap-2 text-secondary-700">
              <i className="ri-checkbox-circle-line text-xl"></i>
              <span className="text-sm font-medium">订阅成功！感谢您的关注。</span>
            </div>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row items-center gap-3"
          >
            <div className="relative flex-1 w-full">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="ri-mail-line text-foreground-400"></i>
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的邮箱地址"
                required
                className="w-full pl-11 pr-4 py-3 rounded-full bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
            </div>

            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />

            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === 'error' && errorMsg && (
          <p className="text-sm text-red-500 mt-3">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}